import React, { useState } from "react";
import './ProfileNavigate.css';
import { NavLink } from 'react-router-dom';
import { UserContext } from "../../context/UserContext";
import { useAuth } from "../../context/AuthContext";
import { UserAppointments } from "../../context/AppointmentsContext";
import PopUpConfirm from "../Shared/PopUpConfirm/PopUpConfirm";
import {
    FaTable,
    FaUserCog,
    FaSignOutAlt,
    FaLock
} from "react-icons/fa";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const ProfileNavigate = () => {

    const { user, logout } = useAuth(UserContext);
    const [isModalOpen, setIsModalOpen] = useState(false);

    const showConfirm = () => setIsModalOpen(true);
    const closeConfirm = () => setIsModalOpen(false);

    // const [userDoctor, setUserDoctor] = useState(null)
    // const [appointments, setAppointments] = useState([])
    const { appointments, fetchAppointments } = UserAppointments();

    const deactivate = async () => {
        if (!user || !user.id) {
            console.error("Brak ID użytkownika!");
            return;
        }

        try {
            const response = await fetch(`${API_BASE_URL}/api/user/deleteUser/${user.id}`, {
                method: "GET",
                headers: { "Content-Type": "application/json" }
            });

            if (!response.ok) {
                throw new Error("Błąd podczas usuwania konta");
            }

            logout();
        } catch (error) {
            console.error("Error:", error);
        }
    };

    return (
        <>
            <div className="profile-sidebar p-3 rounded">
                <div className="p-2 text-center border-bottom">
                    <div className="profile-info text-center">
                        <div className='profile-details'>
                            <h5 className='mb-0'>{user?.firstName + " " + user?.lastName}</h5>
                            <div className='mt-2'>
                                {user.dateOfBirth && (
                                    <p className='form-text m-0'>Data urodzin: {user.dateOfBirth}</p>
                                )}
                                <p className=' form-text m-0'>{user?.email}</p>
                            </div>
                        </div>
                    </div>

                </div>
                <nav className="dashboard-menu">
                    <ul>
                        <li>
                            <NavLink to={'/dane-uzytkownika'}>
                                <FaUserCog className="icon" />
                                <span>Twoje Dane</span>
                            </NavLink>
                        </li>
                        <li>
                            <NavLink to={'/twoje-wizyty'} 
                            onClick={() => fetchAppointments(user)}
                            state={{ appointments }}
                            >
                                <FaTable className="icon" />
                                <span>Twoje wizyty</span>
                            </NavLink>
                        </li>
                        {/* <li>
                            <NavLink to={'/dashboard/zmien-haslo'}>
                                <FaLock className="icon" />
                                <span>Zmień hasło</span>
                            </NavLink>
                        </li> */}
                        <li>
                            <NavLink to='' onClick={showConfirm} className="remove-account-btn">
                                <FaSignOutAlt className="icon" />
                                <span>Usuń konto</span>
                            </NavLink>
                        </li>
                        <li>
                            <NavLink to={'/'} onClick={logout}>
                                <FaSignOutAlt className="icon" />
                                <span>Wyloguj</span>
                            </NavLink>
                        </li>
                        <PopUpConfirm 
                            isOpen={isModalOpen} 
                            onClose={closeConfirm} 
                            onConfirm={() => {
                                deactivate();
                                closeConfirm();
                            }} 
                        />
                    </ul>
                </nav>
            </div>
        </>
    );
}

export default ProfileNavigate;